import { FC } from 'react'
import { Streamdown } from 'streamdown'
import { cn } from '../../../lib/utils'

interface MessageMarkdownProps {
  content: string
  className?: string
}

/**
 * Clinical Intelligence prose styling for chat message bodies. The single source
 * of truth shared by MessageMarkdown AND the inline-citation render path in
 * ChatMessages, so the two rendering branches cannot silently drift apart (#196 —
 * the refactor that introduced MessageMarkdown left the citation branch on a
 * hand-copied class list).
 */
export const MESSAGE_PROSE_CLASSES = [
  'prose prose-sm max-w-none dark:prose-invert',
  'prose-headings:font-display',
  'prose-ol:list-decimal prose-ol:pl-5 prose-ol:my-2',
  'prose-ul:list-disc prose-ul:pl-5 prose-ul:my-2',
  'prose-li:my-1 [&_li>p]:inline [&_li>p:first-child]:inline',
  'prose-code:text-primary prose-code:bg-surface prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded prose-code:font-mono prose-code:text-sm prose-code:before:content-none prose-code:after:content-none',
  'prose-pre:bg-surface prose-pre:border prose-pre:border-border/50 prose-pre:rounded-xl',
  'prose-a:text-primary prose-a:no-underline hover:prose-a:underline',
] as const

/**
 * Shared markdown body for chat messages. Wraps Streamdown with the
 * Clinical Intelligence prose styling used across both chat surfaces
 * (general ChatMessages and the case-panel CasePanelMessage).
 */
export const MessageMarkdown: FC<MessageMarkdownProps> = ({ content, className }) => (
  <div className={cn(...MESSAGE_PROSE_CLASSES, className)}>
    <Streamdown>{content}</Streamdown>
  </div>
)
